import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConst } from '@shared/app-const';
import { TokenConnection } from '@shared/interfaces/token-connection.interface';
import { TErpAuthIntegrationInterceptor, TErpAuthIntegrationService } from '@totvs/common-api';
import { BehaviorSubject, catchError, filter, finalize, Observable, switchMap, take, throwError } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service';

let isRefreshing = false;
let tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

export const TotvsTokenInterceptor: HttpInterceptorFn = (request, next) => {

  const authErpInterceptor = inject(TErpAuthIntegrationInterceptor);
  const authErpService:TErpAuthIntegrationService = inject(TErpAuthIntegrationService);

  if (requestePermitida(request.url))
    return next(request);

  const requestModified = requestSmartUI(request);

  let accessToken = dadosDeAcesso().access_token;
  return next(adicionaToken(requestModified, accessToken)).pipe(
    catchError(error => handleError(error, requestModified, next, authErpInterceptor, authErpService))
  )
}

function requestePermitida(url: string): boolean {
  return url.includes(AppConst.URL_LOGIN) || url.includes(AppConst.URL_ALIAS);
}

function requestSmartUI(req: HttpRequest<any>): HttpRequest<any> {

  const service = inject(AppConfigService);
  const apiServer = service.retornaApiServer();

  const urls = [
    AppConst.URL_FILTROS,
    AppConst.URL_FILTROAVANCADO,
    AppConst.URL_FILTRO_AVANCADO_CONTACAIXA_SCHEMA,
    AppConst.URL_FILTRO_AVANCADO_LANCAMENTO_SCHEMA,
  ];

  const match = urls.find(url => req.url.includes(url));

  if(match){
    const urlPath = req.url.split('/api')[1];
    const newUrl = `${apiServer}/api${urlPath}`;
    return req.clone({ url: newUrl });
  }

  return req;
}

function adicionaToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
  return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
}

function handleError(error: any, req: HttpRequest<any>, next: HttpHandlerFn,
  authErpInterceptor: TErpAuthIntegrationInterceptor, authErpService:TErpAuthIntegrationService): Observable<HttpEvent<any>> {

  if (error.status !== 401) {
    return throwError(() => error);
  }

  if (!isRefreshing) {
    isRefreshing = true;
    tokenSubject.next(null);

    const refreshToken = dadosDeAcesso()?.refresh_token;
    if (!refreshToken) {
      return throwError(() => new Error('Refresh token ausente'));
    }

    return (authErpInterceptor as any).refreshTokenApi(refreshToken).pipe(
      switchMap((newToken:TokenConnection) => {
        iniciaSessaoComToken(newToken, authErpService);
        tokenSubject.next(newToken.access_token);
        return next(adicionaToken(req, newToken.access_token));
      }),
      catchError(refreshError => {
        return throwError(() => refreshError);
      }),
      finalize(() => {
        isRefreshing = false;
      })
    );

  } else {
    return tokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(newToken => {
        return next(adicionaToken(req, newToken));
      })
    );
  }
}

function iniciaSessaoComToken(dadosNovosToken:any, authErpService:TErpAuthIntegrationService) {
  const idTokenAntigo = dadosDeAcesso().$id;
  sessionStorage.removeItem(AppConst.CHAVE_TOKENS);
  (window as any)[AppConst.CHAVE_TOKENS] = {
    $id: idTokenAntigo,
    access_token: dadosNovosToken.access_token,
    refresh_token: dadosNovosToken.refresh_token
  }

  authErpService.load();
}

function dadosDeAcesso() {
  const tokenJson = JSON.parse(sessionStorage.getItem(AppConst.CHAVE_TOKENS) || 'false');
  if(tokenJson) return tokenJson;
  return false
}
